/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Caption_Lock_Aria_LabelInputs */

const en_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Lock`)
};

const fr_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillage des Sous-titres`)
};

const de_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Sperre`)
};

const it_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco didascalia`)
};

const ru_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокировка подписи`)
};

const es_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueo de subtítulos`)
};

const zh_cn2_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕锁定`)
};

const ja_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションロック`)
};

const hi_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन लॉक`)
};

const pt_pt2_player_caption_lock_aria_label = /** @type {(inputs: Player_Caption_Lock_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio de legenda`)
};

/**
* | output |
* | --- |
* | "Caption Lock" |
*
* @param {Player_Caption_Lock_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_caption_lock_aria_label = /** @type {((inputs?: Player_Caption_Lock_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Caption_Lock_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_caption_lock_aria_label(inputs)
	if (locale === "de") return de_player_caption_lock_aria_label(inputs)
	if (locale === "it") return it_player_caption_lock_aria_label(inputs)
	if (locale === "ru") return ru_player_caption_lock_aria_label(inputs)
	if (locale === "es") return es_player_caption_lock_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_caption_lock_aria_label(inputs)
	if (locale === "ja") return ja_player_caption_lock_aria_label(inputs)
	if (locale === "hi") return hi_player_caption_lock_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_caption_lock_aria_label(inputs)
	return en_player_caption_lock_aria_label(inputs)
});